import React from 'react';
import Lottie from 'react-lottie';
import './Green_Check_Lottie.css';
import * as animationData from './Green_Check_Lottie.json';

const Green_Check_Lottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            <section className='main'>
                <div className='Green_Check_Lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                    // height={60}
                    // width={60}          
                    />
                </div>
            </section>
        </>
    )
}

export default Green_Check_Lottie
